import * as React from 'react';

import { Grid,  Button, Checkbox, Link } from '@material-ui/core';
import { Theme, withStyles, WithStyles } from '@material-ui/core/styles';
import { MuiThemeProvider } from '@material-ui/core/styles';

import { Trans, TransProps, WithTranslation, withTranslation } from 'react-i18next';

import { window2config } from '../../cfg/config';
import CONFIG from '../../cfg/config';

import { List, ListItem, Typography, ListItemText, ListItemIcon } from '@material-ui/core';
import { connect } from 'react-redux';

import { AppState, Actions, store, IPageState } from '../../appredux';

import { hotelService, webHotel, PortalInfo, Info, webRooms, roomsService, webRoom, passService, Bramka, Result, resetService } from '../../api';
import { ClassNameMap } from '@material-ui/styles';
import theme from '../../themes';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import FacebookIcon from '@mui/icons-material/Facebook';
import ProductionQuantityLimitsIcon from '@mui/icons-material/ProductionQuantityLimits';
import ElectricalServicesIcon from '@mui/icons-material/ElectricalServices';
import DescriptionIcon from '@mui/icons-material/Description';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import ArticleIcon from '@mui/icons-material/Article';

interface DoladujKarnetProps {
  page: IPageState,
}

interface DoladujKarnetState {

}



class DoladujKarnet extends React.Component<DoladujKarnetProps & WithTranslation & TransProps & WithStyles<typeof styles>, DoladujKarnetState> {

  constructor(props: DoladujKarnetProps & WithTranslation & WithStyles<typeof styles>) {
    super(props, {});
    window2config();
   
    this.state = {
      openPlatnosc: false,
    }
  }

  componentDidMount() {
  }

  link1 = () => {
    //window.open("", "_blanc")
  }

  
  render() {
    const { classes, t } = this.props;
    let primary = theme.palette.primary.main
    

      return (
          <Grid container spacing={2} className={classes.container1} justify="center" alignItems="center"  >         
              <Grid item xs={12} sm={12} className={classes.gridItem} >

                  <div style={{width: "fit-content", margin: "auto"}}>
                      <Typography variant="h6" component="h2" onClick={() => this.link1()} color='textSecondary' className={classes.text} style={{}}>
                          <ArticleIcon className={classes.icon} />
                          <Link href={`https://vsc24.net/vscZasady/zasady/Regulamin/${CONFIG.karnetZasady3Link}`} target='_blank' underline="hover" className={classes.color}>{'rodo'}</Link>
                          {/* {"Ty lajkujesz"}<b className={classes.primary} >{ }</b> */}
                      </Typography>
                  </div>

              </Grid>
          </Grid>
      );
  }
}

const styles = (theme: Theme) => ({
    primary: {
        color: theme.palette.primary.main
      },
      color: {
        color: "lightseagreen"
      },
      text: {
        color: theme.palette.text.secondary,
        whiteSpace: "pre" as "pre",
        minHeight: "12px",
        marginBottom: '12px',
        fontSize: "16px",
        cursor: "pointer",

        display: "flex" as "flex",
        justyfyContent: "center",
        alignItems: "center"
      },
      icon: {
        fontSize: "30px", 
        color: "rgb(255, 165, 0)", 
        marginRight: "10px"
      },

  container1: {
    //marginTop: "15pxs",
    //paddingTop: "0.4em",
    margin: "30px auto 0px",
    padding: '0em 0em',
    minHeight: "100%",
    maxWidth: "1340px",
    //border: "2px solid lavender"
  },
  gridItem: {
    minHeight: "150px",
    //display: "contents"
  },
  item: {
    height: "40px",
    textAlign: "center" as "center",
    border: "1px solid lavender",
    marginBottom: "4px",
    backgroundColor: "#FCFCFC", //"#F5F5F5",
    "&:hover": {
      backgroundColor: "#F1F1F1", //"#EEE"
    },
  },
  itemText: {
    color: "rgb(255, 165, 0)",
    fontSize: "16px"//"2.5rem"
  }
 
  
 
});

const mapStateToProps = (state: AppState) => ({
  page: state.pageState
});

export default connect(mapStateToProps)(withTranslation()(withStyles(styles)(DoladujKarnet))); 

